import React from "react";
import { StyleSheet, css } from "aphrodite";

export default function Description(){
    const styles = StyleSheet.create({

        containerStyle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: ' center',
            alignItems: 'center',
            backgroundColor: '#011a39',
            "@media (min-width: 1024px)": {
                gap: '40px',
                width: '100%',
                height: '500px',            
            }
        },
        firstTitleStyle: {
            color: '#fec803',
            fontFamily: 'Oswald',
            fontStyle: "bold",
            fontSize: "3rem",
            textAlign: "center",
            
        },
        secondContainerStyle: {
            display: 'flex',
            justifyContent: ' center',
            alignItems: 'center',
            flexDirection:'column',
            padding: '0 10px 20px 10px',
            gap: '3rem',
            "@media (min-width: 1024px)": {        
                gap: '10rem',
                width: '80%',
                flexDirection:'row'
            }
        },
        secondTitleStyle: {
            color: '#fec803',
            fontFamily: "Oswald",
            fontSize:'1.5rem',
            fontStyle: "bold",

        },
        thirdContainerStyle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: ' center',
            alignItems: 'center',
            gap: '1rem'
        },
        mainTextStyle: {
            color: '#F0EFEC',
            textAlign: 'justify',
            fontFamily: "Montserrat",
        },

        imageStyle: {
            height:'15rem',
            borderRadius: '10px',
            "@media (min-width: 1024px)": {
                height: '20rem',        
            }
        }
    })
    return(
        <>
            <div className={css(styles.containerStyle)}>
                <div className={css(styles.firstTitleStyle)}>ABOUT US</div>
                <div className={css(styles.secondContainerStyle)}>
                    <div className={css(styles.thirdContainerStyle)}>
                        <div className={css(styles.secondTitleStyle)}>Crafting Quality Products, Built to Last</div>
                        <div className={css(styles.mainTextStyle)}>At JF Welding, we’re passionate about providing high-quality trailers that deliver unmatched durability and performance for every job. With our experience in the welding manufacturing industry, we’ve built a reputation for excellence, craftsmanship, and customer satisfaction. Whether you need a reliable utility trailer for everyday use or a custom-built solution for specialized needs, our team is dedicated to delivering products that stand the test of time. We use only the best materials and the latest manufacturing techniques to ensure that every trailer we produce meets the highest standards of quality and safety. Our commitment to innovation and customer service is at the heart of everything we do, and we take pride in offering personalized solutions that are tailored to your specific requirements. At JF Welding, we don’t just build trailers—we build lasting partnerships with our customers.</div>
                    </div>
                    <div>
                        <img className={css(styles.imageStyle)} src="/resources/Picture3.png"></img>
                    </div>
                </div>
            </div>
        </>
    )
}